module.exports = __webpack_public_path__ + "img/GAME_JANGGI1.2ba57eb0.jpg";